module.exports = __webpack_public_path__ + "img/wallpaper.31817655.jpg";